import { css } from '@emotion/react';
// Etc
import { arrowGenerator } from './ArrowGenerator';
import { Color } from '../../constants/Colors';

export const useStyles = () => ({
    arrow: css({
        color: Color.primary[900]
    }),
    popper: css(arrowGenerator(Color.primary[900])),
    tooltip: css({
        position: 'relative',
        borderRadius: 0,
        padding: 10,
        backgroundColor: Color.primary[900],
        color: Color.neutral[100],
        boxShadow: '0px 2px 16px 0px rgba(0, 0, 0, 0.25)',
    }),
    tooltipPlacementLeft: css({
        margin: '0 8px',
    }),
    tooltipPlacementRight: css({
        margin: '0 8px',
    }),
    tooltipPlacementTop: css({
        margin: '8px 0',
    }),
    tooltipPlacementBottom: css({
        margin: '8px 0',
    }),
});
